<template>
  <!-- 本组件为：点状图，如soc详情页的点状图 -->
  <div :style="{height:height,width:width}">
    <el-button v-if="!isShowDeleteBtn" :disabled="canEditBtn" type="primary" class="btn" @click="openHXFn">{{ $t('socDetailPage.StartDrawingLine') }}</el-button>
    <el-button v-else type="primary" class="btn" @click="deleHXFn">{{ $t('socDetailPage.DeleteLine') }}</el-button>
    <p v-show="isShowNoData" style="position: absolute;width: 100%;top: 250px;z-index: 999;text-align: center;">{{ $t("socDetailPage.NoRecord") }}</p>
    <div ref="point" :class="className" :style="{height:height,width:width}" style="position:relative;" @click="clickEchart" />
  </div>
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import { getDateAndHour } from '@/utils/updateTime.js'
import i18n from '@/i18n'
var offsetWid, offsetHei
var xAxisMax, yAxisMax // 数据里最大的x和y
var xMax, yMax // x和y轴最大值
var myColor = [
  '#30c7c9', '#b6a2de', '#59b1ef', '#ffb980',
  '#d87980', '#8c98b3', '#e5ce2c', '#97b552',
  '#996666', '#cc6699', '#339999', '#9966cc',
  '#6699cc', '#ff9933', '#cc6666', '#666699'
]
var markLineOpt = {
  animation: false,
  label: {
    normal: {
      formatter: '',
      textStyle: {
        align: 'right'
      }
    }
  },
  lineStyle: {
    normal: {
      type: 'solid'
    }
  },
  tooltip: {
    formatter: ''
  },
  data: [
    [
      { coord: [0, 0], symbol: 'none' },
      { coord: [0, 0], symbol: 'none' }
    ]
    // [
    //   {coord: [0, 0],symbol: 'none'},
    //   {coord: [43, 61],symbol: 'none'}
    // ],
  ]
}
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    seriesData: {
      type: Array,
      default: () => []
    },
    batteryCapacity: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chart: null,
      yAxisDatas: [],
      mySeriesData: [],
      legendData: [],
      openHX: 0, // 当只有原点时，必须点开始画线才可以画线
      isShowDeleteBtn: false,
      canEditBtn: true, // 图表渲染出来后才可以画线
      isShowNoData: false
    }
  },
  watch: {
    seriesData: {
      handler(newValue, oldValue) {
        this.seriesData = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 50)
    setTimeout(() => {
      this.watchChangeSize()
    }, 500)
    //  监听窗口大小改变（先移除再监听，防止出错）
    window.removeEventListener('resize', e => {
      this.watchChangeSize()
    }, false)
    window.addEventListener('resize', e => {
      this.watchChangeSize()
    }, false)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
    window.removeEventListener('resize', e => {
      this.watchChangeSize()
    }, false)
  },
  methods: {
    initChart() {
      var that = this
      var xAxisArr = []
      var yAxisArr = []
      if (this.seriesData.length == 0) { this.isShowNoData = true } else { this.isShowNoData = false }
      // console.log('this.seriesData----------', this.seriesData)
      this.seriesData.forEach(v => {
        xAxisArr.push(v[0])
        yAxisArr.push(v[1])
      })
      xAxisMax = Math.max(...xAxisArr)
      yAxisMax = Math.max(...yAxisArr)
      xMax = Math.ceil(xAxisMax * 1.1)
      yMax = Math.ceil(yAxisMax * 1.1)
      this.chart = echarts.init(this.$refs.point)
      var option = {
        title: {
          text: i18n.t('socDetailPage.PowerDifference') + ' VS ' + i18n.t('socDetailPage.SOCDifference'),
          x: 'center',
          y: '20px'
        },
        grid: [
          { x: '5%', y: '70px', width: '85%', height: '75%' }
        ],
        tooltip: {
          formatter: function(param, ticket, callback) {
            // console.log('param----', param)
            var htmlStr = ''
            htmlStr += '<div>'
            // 圆点
            var radiuSpan1 = '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:'
            var radiuSpan2 = ';"></span>'
            htmlStr += getDateAndHour(param[0].value[2]) + '<br/>'
            if (that.batteryCapacity)htmlStr += radiuSpan1 + myColor[2] + radiuSpan2 + i18n.t('yhubReport.Capacity') + '：' + that.batteryCapacity / 100 + 'Ah' + '<br/>'
            htmlStr += radiuSpan1 + myColor[0] + radiuSpan2 + i18n.t('socDetailPage.SOCDifference') + '：' + param[0].value[0] + '(Ah)<br/>'
            htmlStr += radiuSpan1 + myColor[1] + radiuSpan2 + i18n.t('socDetailPage.PowerDifference') + '：' + param[0].value[1] + '(Ah)<br/>'
            htmlStr += '</div>'
            return htmlStr
          },
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        xAxis: [
          { name: i18n.t('socDetailPage.SOCDifference') + '(AH)',
            gridIndex: 0,
            min: 0,
            max: xMax,
            splitLine: {
              show: true,
              interval: 'auto',
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        yAxis: [
          // { name: '用电差值', gridIndex: 0, min: 0, max: Math.ceil(yMax * 1.1) }
          {
            name: i18n.t('socDetailPage.PowerDifference') + '(AH)',
            gridIndex: 0,
            min: 0,
            max: yMax,
            splitLine: {
              show: true,
              interval: 'auto',
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        dataZoom: [
          {
            type: 'slider',
            show: true,
            id: 'sliderX',
            xAxisIndex: [0],
            start: 0,
            end: 100
          },
          {
            type: 'inside',
            orient: 'vertical',
            yAxis: [0],
            start: 0,
            end: 100
          }
        ],
        series: [
          {
            name: 'II',
            type: 'scatter',
            xAxisIndex: 0,
            yAxisIndex: 0,
            data: this.seriesData,
            markLine: markLineOpt
          }
        ]
      }
      this.chart.setOption(option, true)
      this.canEditBtn = false
    },
    openHXFn() {
      this.openHX = 1
      this.isShowDeleteBtn = true
    },
    watchChangeSize() {
      offsetWid = this.$refs.point.clientWidth
      offsetHei = this.$refs.point.clientHeight
    },
    clickEchart(param) {
      // console.log(param)
      // console.log(param.path[2].textContent)
      if (this.openHX == 1) {
        var lastData = markLineOpt.data[markLineOpt.data.length - 1]
        // var textContent=param.path[2].textContent
        // var soc=parseFloat(textContent.split('SOC电量：')[1])
        // var total=parseFloat(textContent.split('统计电量：')[1]) //用处方法描的线都是已有的点连接
        var m = 80 // 图表与容器底部的距离
        var n = offsetWid * 0.05 // 图表往右偏移的距离
        // offsetWid*0.85：图表方格取的宽/ offsetHei*0.75：图表方格区的高
        // param.offsetHei-param.offsetY-m:鼠标点距方格下边距 yMax / (offsetHei * 0.75)：1px的长度所代表的Y轴值
        var x = (xMax / (offsetWid * 0.85)) * (param.offsetX - n)
        var y = (yMax / (offsetHei * 0.75)) * (offsetHei - param.offsetY - m)
        if (x >= 0 && x <= xMax && y >= 0 && y <= yMax) { // 点到方格外面的线无效
          markLineOpt.data.push([lastData[1], { coord: [x, y], symbol: 'none' }])
          this.initChart()
        }
      }
    },
    deleHXFn() {
      if (markLineOpt.data.length > 1) { // 不删除原点
        markLineOpt.data.pop()
        this.initChart()
      }
      if (markLineOpt.data.length == 1) {
        this.isShowDeleteBtn = false
        this.openHX = 0
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.btn{
  position: absolute;
  right: 20px;
  top: 20px;
  z-index:999;
}
</style>
